import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { QA_NAME_SAVE_BTN } from '../../../constants/qa'
import { SIZE } from '../../../constants/size'
import { FormModal } from '../../Form'

import { QA_NAME_REQUEST_EDIT_CATEGORY_FORM_MODAL } from './RequestEditCategoryModal.constants'
import {
  getRequestEditCategoryModalPayload,
  getRequestEditCategoryModalValidationSchema,
} from './RequestEditCategoryModal.utils'
import { RequestEditCategoryModalFields } from './RequestEditCategoryModalFields'

function RequestEditCategoryModal({
  getPayload = getRequestEditCategoryModalPayload,
  initialValues,
  itemAction,
  validationSchema: validationSchemaProp,
  onSubmit,
  ...restProps
}) {
  const validationSchema =
    validationSchemaProp ??
    getRequestEditCategoryModalValidationSchema({
      initialValues,
      itemAction,
    })

  function handleSubmit({ values }) {
    onSubmit({ payload: getPayload(values), values })
  }

  const formBodyProps = {
    ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
    submitQaName: QA_NAME_SAVE_BTN,
  }

  return (
    <FormModal
      {...restProps}
      Fields={RequestEditCategoryModalFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: QA_NAME_REQUEST_EDIT_CATEGORY_FORM_MODAL,
      }}
      formBodyProps={formBodyProps}
      formTitle='Modal.EditCategoryTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestEditCategoryModal
